module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="documentsPanel">\n    <fieldset class="group" style="left: -8px; top: 0px; width: 100%;">\n        <legend class="groupTitle">\n            <div class="groupSquare"></div>\n            <div class="groupTitleText">Documents associés</div>\n        </legend>\n    </fieldset>\n    <div class="docsContainer">\n        <div class="bubblingG centeredSpinner"><span class="bubblingG_1"></span><span class="bubblingG_2"></span><span class="bubblingG_3"></span></div>\n        <div class="docHolder">\n        </div>\n    </div>\n</div>';

}
return __p
}